module.exports = __webpack_public_path__ + "img/brand-sass.b4bfecff.svg";